// extracted by mini-css-extract-plugin
module.exports = {"inner":"_3DIttl-zB4Qi4iWP3F9W3y"};